// TimesheetSyncPanel.jsx
import React, { useEffect, useState } from 'react'
import { apiGet, apiPost } from '../../utils/apiFetch'
import apiPath from '../../utils/apiPath'
import useToastContext from 'hooks/useToastContext'
import { FaSync, FaCheckCircle, FaExclamationCircle, FaClock } from 'react-icons/fa'
import dayjs from 'dayjs'
import Swal from 'sweetalert2'
import { useMFA } from 'context/MFAContext'
import { callWithStepUp } from 'utils/payrollMfa'

const TimesheetSyncPanel = () => {
  const notification = useToastContext()
  const { requireMfa } = useMFA()
  const [timesheets, setTimesheets] = useState([])
  const [selectedIds, setSelectedIds] = useState([])
  const [loading, setLoading] = useState(false)
  const [syncing, setSyncing] = useState(false)

  const getPendingTimesheets = async () => {
    try {
      setLoading(true)
      const res = await apiGet(apiPath.timesheetPendingSync)
      if (res?.data?.success) {
        setTimesheets(res.data.results || [])
      }
    } catch (err) {
      console.log('Error fetching pending timesheets:', err.message)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => { getPendingTimesheets() }, [])

  const toggleSelect = (id) => {
    setSelectedIds(prev =>
      prev.includes(id) ? prev.filter(i => i !== id) : [...prev, id]
    )
  }

  const toggleSelectAll = () => {
    if (selectedIds.length === timesheets.length) {
      setSelectedIds([])
    } else {
      setSelectedIds(timesheets.map(t => t._id))
    }
  }

// const syncSelected = async () => {
//   if (selectedIds.length === 0) {
//     notification.error('Please select at least one timesheet to sync')
//     return
//   }

//   // Confirm before syncing using SweetAlert
//   const result = await Swal.fire({
//     title: 'Confirm Sync',
//     html: `
//       <div class="text-left">
//         <p class="mb-2">You are about to sync <strong>${selectedIds.length}</strong> timesheet(s) to Everee.</p>
//         <p class="text-sm text-gray-600">This will push hours data to Everee for payroll processing.</p>
//         <div class="mt-3 p-3 bg-yellow-50 border border-yellow-200 rounded-md text-sm text-yellow-800">
//           ⚠️ Please ensure all timesheets are approved before syncing.
//         </div>
//       </div>
//     `,
//     icon: 'question',
//     showCancelButton: true,
//     confirmButtonColor: '#4F46E5',
//     cancelButtonColor: '#6B7280',
//     confirmButtonText: 'Yes, Sync Now',
//     cancelButtonText: 'Cancel',
//     reverseButtons: true,
//     width: 450,
//     customClass: {
//       confirmButton: 'px-4 py-2 text-white rounded-md hover:bg-[#4338CA]',
//       cancelButton: 'px-4 py-2 text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200',
//     }
//   })

//   if (!result.isConfirmed) return

//   try {
//     setSyncing(true)
//     const res = await apiPost(apiPath.timesheetSync, { timesheetIds: selectedIds })
//     if (res?.data?.success) {
//       const { syncedCount, failures } = res.data.results || {}
//       if (failures?.length) {
//         // Show failure details in SweetAlert
//         await Swal.fire({
//           title: 'Partial Sync',
//           html: `
//             <div class="text-left">
//               <p class="mb-2">Synced <strong>${syncedCount || 0}</strong> timesheets, <strong class="text-red-600">${failures.length}</strong> failed.</p>
//               <div class="mt-3 max-h-48 overflow-y-auto bg-red-50 p-3 rounded-md text-sm">
//                 ${failures.map((f, i) => `<div key=${i} class="py-1 border-b border-red-100 last:border-0">❌ ${f.message || 'Sync failed'}</div>`).join('')}
//               </div>
//             </div>
//           `,
//           icon: 'warning',
//           confirmButtonColor: '#4F46E5',
//           confirmButtonText: 'OK',
//         })
//         console.log('Sync failures:', failures)
//       } else {
//         await Swal.fire({
//           title: 'Success!',
//           html: `
//             <p>Successfully synced <strong>${syncedCount || selectedIds.length}</strong> timesheet(s) to Everee</p>
//             <div class="mt-2 text-sm text-green-600">✅ All timesheets processed successfully</div>
//           `,
//           icon: 'success',
//           confirmButtonColor: '#4F46E5',
//           confirmButtonText: 'OK',
//           timer: 3000,
//           timerProgressBar: true,
//         })
//       }
//       setSelectedIds([])
//       getPendingTimesheets()
//     } else {
//       await Swal.fire({
//         title: 'Sync Failed',
//         html: `<p>${res?.data?.message || 'Failed to sync timesheets to Everee'}</p>`,
//         icon: 'error',
//         confirmButtonColor: '#4F46E5',
//         confirmButtonText: 'OK',
//       })
//     }
//   } catch (err) {
//     await Swal.fire({
//       title: 'Error',
//       html: `<p>Something went wrong while syncing timesheets</p>
//              <p class="text-sm text-gray-500 mt-2">Please try again or contact support if the issue persists.</p>`,
//       icon: 'error',
//       confirmButtonColor: '#4F46E5',
//       confirmButtonText: 'OK',
//     })
//   } finally {
//     setSyncing(false)
//   }
// }
  const syncSelected = async () => {
    if (selectedIds.length === 0) {
      notification.error('Please select at least one timesheet to sync')
      return
    }

    // Confirm before syncing using SweetAlert
    const result = await Swal.fire({
      title: 'Confirm Sync',
      html: `
      <div class="text-left">
        <p class="mb-2">You are about to sync <strong>${selectedIds.length}</strong> timesheet(s) to Everee.</p>
        <p class="text-sm text-gray-600">This will push hours data to Everee for payroll processing.</p>
        <div class="mt-3 p-3 bg-yellow-50 border border-yellow-200 rounded-md text-sm text-yellow-800">
          ⚠️ Please ensure all timesheets are approved before syncing.
        </div>
      </div>
    `,
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#4F46E5',
      cancelButtonColor: '#6B7280',
      confirmButtonText: 'Yes, Sync Now',
      cancelButtonText: 'Cancel',
      reverseButtons: true,
      width: 450,
      customClass: {
        confirmButton: 'px-4 py-2 text-white rounded-md hover:bg-[#4338CA]',
        cancelButton: 'px-4 py-2 text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200',
      }
    })

    if (!result.isConfirmed) return

    try {
      setSyncing(true)
      const res = await callWithStepUp(requireMfa, (extra) =>
        apiPost(apiPath.timesheetSync, { timesheetIds: selectedIds, ...extra })
      )
      if (!res) {
        notification.error('Verification cancelled')
        return
      }
      if (res?.data?.success) {
        const { syncedCount, failures } = res.data.results || {}
        if (failures?.length) {
          await Swal.fire({
            title: 'Partial Sync',
            html: `
            <div class="text-left">
              <p class="mb-2">Synced <strong>${syncedCount || 0}</strong> timesheets, <strong class="text-red-600">${failures.length}</strong> failed.</p>
              <div class="mt-3 max-h-48 overflow-y-auto bg-red-50 p-3 rounded-md text-sm">
                ${failures.map((f, i) => `<div key=${i} class="py-1 border-b border-red-100 last:border-0">❌ ${f.message || 'Sync failed'}</div>`).join('')}
              </div>
            </div>
          `,
            icon: 'warning',
            confirmButtonColor: '#4F46E5',
            confirmButtonText: 'OK',
          })
          console.log('Sync failures:', failures)
        } else {
          await Swal.fire({
            title: 'Success!',
            html: `
            <p>Successfully synced <strong>${syncedCount || selectedIds.length}</strong> timesheet(s) to Everee</p>
            <div class="mt-2 text-sm text-green-600">✅ All timesheets processed successfully</div>
          `,
            icon: 'success',
            confirmButtonColor: '#4F46E5',
            confirmButtonText: 'OK',
            timer: 3000,
            timerProgressBar: true,
          })
        }
        setSelectedIds([])
        getPendingTimesheets()
      } else {
        await Swal.fire({
          title: 'Sync Failed',
          html: `<p>${res?.data?.message || 'Failed to sync timesheets to Everee'}</p>`,
          icon: 'error',
          confirmButtonColor: '#4F46E5',
          confirmButtonText: 'OK',
        })
      }
    } catch (err) {
      await Swal.fire({
        title: 'Error',
        html: `<p>Something went wrong while syncing timesheets</p>
             <p class="text-sm text-gray-500 mt-2">Please try again or contact support if the issue persists.</p>`,
        icon: 'error',
        confirmButtonColor: '#4F46E5',
        confirmButtonText: 'OK',
      })
    } finally {
      setSyncing(false)
    }
  }

  const getStatusBadge = (ts) => {
    if (ts.everee?.synced) {
      return <span className='inline-flex items-center gap-1 text-green-700 text-xs'><FaCheckCircle className='w-3 h-3' /> Synced</span>
    }
    if (ts.everee?.syncError) {
      return <span className='inline-flex items-center gap-1 text-red-700 text-xs' title={ts.everee.syncError}><FaExclamationCircle className='w-3 h-3' /> Error</span>
    }
    return <span className='inline-flex items-center gap-1 text-yellow-700 text-xs'><FaClock className='w-3 h-3' /> Pending</span>
  }

  return (
    <div className='p-4'>
      <div className='flex items-center justify-between mb-4'>
        <div>
          <h4 className='text-sm font-semibold text-gray-700'>Pending Timesheets ({timesheets.length})</h4>
          <p className='text-xs text-gray-500'>Approved timesheets that haven't been synced to Everee yet</p>
        </div>
        <div className='flex gap-2'>
          <button
            type='button'
            onClick={toggleSelectAll}
            className='px-3 py-1 text-xs border rounded-md hover:bg-gray-50'
          >
            {selectedIds.length === timesheets.length && timesheets.length > 0 ? 'Deselect All' : 'Select All'}
          </button>
          <button
            type='button'
            onClick={syncSelected}
            disabled={syncing || selectedIds.length === 0}
            className='px-3 py-1 bg-[#4F46E5] text-white rounded-md text-xs hover:bg-[#4338CA] disabled:opacity-50 flex items-center gap-1'
          >
            {syncing ? (
              <>
                <span className='animate-spin'>⟳</span> Syncing...
              </>
            ) : (
              <>
                <FaSync className='w-3 h-3' /> Sync Selected ({selectedIds.length})
              </>
            )}
          </button>
        </div>
      </div>

      {loading ? (
        <div className='text-center py-8 text-gray-400'>Loading...</div>
      ) : timesheets.length === 0 ? (
        <div className='text-center py-8 text-gray-400'>No pending timesheets to sync</div>
      ) : (
        <div className='border rounded-lg overflow-hidden'>
          <table className='w-full text-xs text-left text-[#A5A5A5]'>
            <thead className='text-gray-900 text-xs border-b bg-[#E1E6EE]'>
              <tr>
                <th className='px-4 py-2 w-8'>
                  <input
                    type='checkbox'
                    checked={selectedIds.length === timesheets.length && timesheets.length > 0}
                    onChange={toggleSelectAll}
                    className='rounded'
                  />
                </th>
                <th className='px-4 py-2'>Employee</th>
                <th className='px-4 py-2'>Week Range</th>
                <th className='px-4 py-2 text-center'>Regular Hours</th>
                <th className='px-4 py-2 text-center'>Overtime Hours</th>
                <th className='px-4 py-2 text-center'>Status</th>
              </tr>
            </thead>
            <tbody>
              {timesheets.map(ts => (
                <tr key={ts._id} className='bg-white border-b hover:bg-gray-50'>
                  <td className='px-4 py-3'>
                    <input
                      type='checkbox'
                      checked={selectedIds.includes(ts._id)}
                      onChange={() => toggleSelect(ts._id)}
                      className='rounded'
                    />
                  </td>
                  <td className='px-4 py-3'>
                    <div className='font-medium text-gray-900'>{ts.employeeId?.name || 'Unknown'}</div>
                    <div className='text-gray-500 text-[10px]'>{ts.employeeId?.employeeId}</div>
                  </td>
                  <td className='px-4 py-3'>
                    {ts.weekStartDate && ts.weekEndDate ? (
                      `${dayjs(ts.weekStartDate).format('MMM D')} - ${dayjs(ts.weekEndDate).format('MMM D, YYYY')}`
                    ) : 'N/A'}
                  </td>
                  <td className='px-4 py-3 text-center'>{Number(ts.totalRegularHours || 0).toFixed(2)}h</td>
                  <td className='px-4 py-3 text-center'>{Number(ts.totalOvertimeHours || 0).toFixed(2)}h</td>
                  <td className='px-4 py-3 text-center'>{getStatusBadge(ts)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* Sync summary */}
      {selectedIds.length > 0 && (
        <div className='mt-4 text-xs text-gray-500'>
          {selectedIds.length} timesheet(s) selected for sync
        </div>
      )}
    </div>
  )
}

export default TimesheetSyncPanel